import { Button } from "@mui/material";
import { GetFullOrganizationDetails_organization } from "../../views/App/__generated__/GetFullOrganizationDetails";
import CardHESP from "../CardHESP/CardHESP";
import CardHESPTitle from "../CardHESP/CardHESPTitle";
import { Save } from "@mui/icons-material";
import styled from "styled-components";
import QuotaItem from "./QuotaItem";
import gql from "graphql-tag";
import { useMutation } from "react-apollo";
import {
    UpdateOrganizationQuotasMutation,
    UpdateOrganizationQuotasMutationVariables,
} from "./__generated__/UpdateOrganizationQuotasMutation";
import { useState } from "react";
import { OrganizationQuotasInput } from "../../__generated__/globalTypes";
import { toast } from "react-toastify";
import { GET_FULL_ORGANIZATION_DETAILS } from "../../views/App/ManageOrganization";

interface Props {
    organization: GetFullOrganizationDetails_organization;
}

const SectionTitle = styled.h1`
    font-weight: 600;
    font-size: 15px;
`;

const SectionContent = styled.div`
    border-radius: 8px;
    margin-top: 4px;
    margin-bottom: 10px;
    background-color: ${(props) => props.theme.grayBackground};
    border-radius: 8px;
    padding: 12px 10px;
`;

export const UPDATE_ORGANIZATION_QUOTAS = gql`
    mutation UpdateOrganizationQuotasMutation($input: OrganizationQuotasInput!) {
        updateOrganizationQuotas(input: $input) {
            organizationId
        }
    }
`;

export default function OrganizationQuotas({ organization }: Props): JSX.Element {
    const [updateOrganizationQuotas, { loading }] = useMutation<
        UpdateOrganizationQuotasMutation,
        UpdateOrganizationQuotasMutationVariables
    >(UPDATE_ORGANIZATION_QUOTAS);

    const [values, setValues] = useState<OrganizationQuotasInput>({
        maxReportsPerDay: organization.quotas.maxReportsPerDay,
        organizationId: organization.organizationId,
    });

    async function onSave(): Promise<void> {
        try {
            await updateOrganizationQuotas({
                variables: {
                    input: values,
                },
                refetchQueries: [
                    {
                        query: GET_FULL_ORGANIZATION_DETAILS,
                        variables: {
                            organizationId: organization.organizationId,
                        },
                    },
                ],
            });
            toast.success("Quotas updated");
        } catch (_e) {
            toast.error("Updating quotas failed");
        }
    }

    function isValid(): boolean {
        return true;
    }

    return (
        <>
            <CardHESP>
                <CardHESPTitle
                    title="Quotas"
                    button={
                        <Button
                            color="primary"
                            startIcon={<Save />}
                            variant="contained"
                            onClick={onSave}
                            disabled={loading || !isValid()}
                        >
                            {loading ? "Saving..." : "Save"}
                        </Button>
                    }
                />
                <SectionTitle>Reporting</SectionTitle>
                <SectionContent>
                    <QuotaItem
                        title="Max reports per 24 hours"
                        value={values.maxReportsPerDay}
                        onChange={(val: number) =>
                            setValues({
                                ...values,
                                maxReportsPerDay: val,
                            })
                        }
                    />
                </SectionContent>
            </CardHESP>
        </>
    );
}
